
		<div
				*ngIf="OBJ_field_config.tab != true"
				class="form-group"
				[formGroup]="OBJ_form_group">
			<div [formGroupName]="OBJ_field_config.name" class="col-lg-12">
				<ng-container
						*ngFor="let OBJ_field of OBJ_field_config.fields;"
						tigDynamicField
						[OBJ_field_config]="OBJ_field"
						[OBJ_form_group]="getFormGroup()">
				</ng-container>
			</div>
		</div>
	